import type { ActionContext } from "vuex";
import * as mutationTypes from "../mutation-types";

const DEFAULT_AUTHZ_MESSAGE = "この操作を行う権限がありません。";

interface AuthzNotificationsState {
  authzSnackbarVisible: boolean;
  authzSnackbarMessage: string;
}

const state: AuthzNotificationsState = {
  authzSnackbarVisible: false,
  authzSnackbarMessage: DEFAULT_AUTHZ_MESSAGE,
};

const getters = {
  authzSnackbarVisible: (state: AuthzNotificationsState) => state.authzSnackbarVisible,
  authzSnackbarMessage: (state: AuthzNotificationsState) => state.authzSnackbarMessage,
};

const actions = {
  showAuthzError({ commit }: ActionContext<AuthzNotificationsState, unknown>, message: string = DEFAULT_AUTHZ_MESSAGE) {
    commit(mutationTypes.ASSIGN_AUTHZ_SNACKBAR_MESSAGE, { message });
    commit(mutationTypes.ASSIGN_AUTHZ_SNACKBAR_VISIBLE, { visible: true });
  },
  hideAuthzError({ commit }: ActionContext<AuthzNotificationsState, unknown>) {
    commit(mutationTypes.ASSIGN_AUTHZ_SNACKBAR_VISIBLE, { visible: false });
  },
};

const mutations = {
  [mutationTypes.ASSIGN_AUTHZ_SNACKBAR_VISIBLE](state: AuthzNotificationsState, { visible }: { visible: boolean }) {
    state.authzSnackbarVisible = visible;
  },
  [mutationTypes.ASSIGN_AUTHZ_SNACKBAR_MESSAGE](state: AuthzNotificationsState, { message }: { message: string }) {
    state.authzSnackbarMessage = message;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
